import { supabase } from '../lib/supabase';

export const whatsappService = {
  /**
   * Send WhatsApp notification after successful payment
   * FASE 1: This is a stub/hook - actual WhatsApp integration to be implemented
   */
  async sendOrderNotification(orderId) {
    try {
      // Get order details
      const { data: order, error: orderError } = await supabase?.from('orders')?.select(`
          *,
          city:cities_food(name),
          vendor:vendors_food(name, phone)
        `)?.eq('id', orderId)?.single();

      if (orderError) throw orderError;

      // Get order items
      const { data: items, error: itemsError } = await supabase?.from('order_items')?.select('*')?.eq('order_id', orderId);

      if (itemsError) throw itemsError;

      // Compose WhatsApp message
      const message = this.composeOrderMessage(order, items);

      // FASE 1: Log to console (WhatsApp provider integration pending)
      console.log('='?.repeat(60));
      console.log('📱 WHATSAPP NOTIFICATION (STUB)');
      console.log('='?.repeat(60));
      console.log(message);
      console.log('='?.repeat(60));

      // Update notification status
      await supabase?.from('orders')?.update({ notification_sent: true })?.eq('id', orderId);

      // TODO FASE 2: Integrate actual WhatsApp provider
      // await whatsappProvider.send({
      //   to: process.env.VITE_WHATSAPP_CLICCAMI_NUMBER,
      //   message: message
      // });

      return { success: true, message: 'Notification logged (stub)' };
    } catch (error) {
      console.error('Error sending WhatsApp notification:', error);
      return { success: false, error: error?.message };
    }
  },

  composeOrderMessage(order, items) {
    const itemsList = items?.map(item => `  • ${item?.quantity}x ${item?.product_name} - €${item?.line_total?.toFixed(2)}`)?.join('\n');

    return `
🍕 NUOVO ORDINE FOOD DELIVERY

📍 Città: ${order?.city?.name || 'N/A'}
🏪 Esercente: ${order?.vendor?.name || 'N/A'}
📞 Tel. Esercente: ${order?.vendor?.phone || 'N/A'}

👤 Cliente: ${order?.customer_name}
📱 Tel. Cliente: ${order?.customer_phone}
📍 Indirizzo: ${order?.delivery_address}
⏰ Fascia consegna: ${order?.delivery_slot}

🛒 PRODOTTI:
${itemsList}

💰 Totale prodotti: €${order?.products_total?.toFixed(2)}
🚚 Costo consegna: €${order?.delivery_fee?.toFixed(2)}
💳 TOTALE ORDINE: €${order?.order_total?.toFixed(2)}

✅ Pagamento: CONFERMATO
🆔 ID Ordine: ${order?.id}
🔖 Stripe Payment: ${order?.stripe_payment_id || 'N/A'}

${order?.notes ? `📝 Note: ${order?.notes}` : ''}

⚠️ AZIONE RICHIESTA: Gestire ordine manualmente
    `?.trim();
  }
};